import Immutable from 'immutable';

import {
	createModuleState,
	EntitySearchAndDetailModel,
	DefinitionUtils,
	EntityDetailModel,
	FormDefinition as Form,
	FormItemDefinition as FormItem,
	// CrossDefinition as Cross,
	// FileInputDefinition as FileInput,
	TabPaneDefinition as TabPane,
	TabDefinition as Tab,
	ContainerDefinition as Container,
	showMessageBox,
	ModuleHeader,
	ModuleHeaderItem,
	createModelForState,
	CentererDefinition as Centerer,
	CrossDefinition as Cross,
	MessageDefinition,
	ButtonDefinition as Button,
	Button as ButtonComponent,
	REPORTED_EXCEPTION,
	webapi,
	updateEntityTimestamp,
	styled,
	TabularInputDefinition as TabularInput,
} from 'ps-gui';

import { getFormItemLabel, getPhrase } from '../../data/phrases';
import {getLookup} from '../../data/lookup';
import {
	createSearchModel, exportToExcel, getNsndTokenFilterProcessor, getSearchDefinition,
} from '../utils';
import { StatusBubble, Label } from '../submissioncomponents';
import memoizeOne from 'memoize-one';
import { DisclaimerWrapper, getCorrectionMessageDefinition, renderTotalTable, searchTabCustomResultProps, totalSaleMap2Array } from './correctionutils';
import LatestStatus from './lateststatus';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_LIST = Immutable.List([]);
const EMPTY_STATE = createModuleState('AffirmationSubmissionAdmin');



export default class AffirmationSubmissionAdminModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new AffirmationSubmissionAdminModel(this.#data.setIn(name, value));
		} else {
			return new AffirmationSubmissionAdminModel(this.#data.set(name, value));
		}

	}

	setSelectedTabId(value) {
		return this.#setProperty('selectedTabId', value);
	}

	#setInitialized() {
		return new AffirmationSubmissionAdminModel(this.#data.set('initialized', true));
	}

	/**
	 *
	 * @returns {number} cas posledni zmeny jazyka zachycene timto modelem
	 */
	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}

	isDetailOpen() {
		return this.#data.getIn(['esad', 'data', 'isDetailOpen']);
	}


	/*getRoleId() {
		return this.#data.get('roleId');
	}

	getDistributionPeriodId() {
		return this.#data.get('distributionPeriodId');
	}

	setDistributionPeriodId(value) {
		return this.#setProperty('distributionPeriodId', value);
	}

	setRoleId(value) {
		console.log('setRoleId', value);
		return this.#setProperty('roleId', value);
	}*/

	/**
	 * kontroluje, zda se nezmenil jazyk, a pokud ano, nacte znovu data, aby byla v novem jazyce.
	 * volano z modulu pri componentDidUpdate a v pripade, ze se zmenil GlobalContext, tak i componentDidUpdate
	 *
	 * @param globalContext {GlobalContextModel}
	 */
	async checkGlobalContextChange(globalContext) {
		console.log('checkGlobalContetxtChange');
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		return (await this.initialize(globalContext)).#setProperty('languageTimestamp', new Date().getTime());
	}

	async initialize(globalContext) {
		console.log('inicializuji');
		let model = this;
		// model = model.setRoleId(getDefaultValue('affirmationSubmissionPartyRole'));
		// model = model.setDistributionPeriodId(getDefaultValue('affirmationDistributionPeriod'));
		let srch = createSearchModel('/api/dq/sv_affirmation_admin_submission')
			.setOutput([
				'distribution_period',
				'party_id',
				'cinema_attendance_record_count',
				'broadcast_record_count',
				'sale_record_count',
				'correction',
				'imported_from_excel',
				'status',
				'last_submitted',
				'edited_when',
				'admin_comments',
			]);
		model = model.setEntitySearchAndDetail(
			new EntitySearchAndDetailModel()
				.setSearch(srch)
				.setDetail(getDetailModel())
				.onBeforeHideDetail(async model => {
					if (model.getDetail().isModified()) {
						const dlgRes = await showMessageBox(getPhrase('reallyLeaveModifiedAffirmationSubmission'), {type: 'confirm', yesIsNegative: true});
						return dlgRes === 'yes';
					}
				})
				.setNewRowMode(EntitySearchAndDetailModel.NEW_ROW_MODE_LOAD_NULL_ID)
				.setEntityName('affirmationSubmission')
		).#initAnomalies().#initConflicts().#initProducerSummary().#setProperty('langId', globalContext.getLanguageId()).#setInitialized();
		model = await model.#initCurrencies();
		return model;
	}

	async loadData() {
		return this;
	}

	async #initCurrencies() {
		let model = getCurrencyDetailModel();
		model = await model.loadDetail(1);

		return this.#setProperty(
			'currencies',
			model.getState()
		);
	}

	#initAnomalies() {
		return this.#setProperty(
			'anomalies',
			createSearchModel('/api/dq/sv_affirmation_submission_anomaly')
				.setProcessFilter(filter => {
					if (filter.producer_id) {
						filter.producer_match = 1;
					}
					return filter;
				})
				.setOutput([
					'distribution_period_id',
					'type',
					'title',
					'detail',
					'admin_comments',
				])
				.getState()
		);
	}

	#initProducerSummary() {
		return this.#setProperty(
			'producerSummary',
			createSearchModel('/api/dq/sv_affirmation_producer_summary').setEntityName('producerSummary').getState()
		);
	}


	#initConflicts() {
		return this.#setProperty(
			'conflicts',
			createSearchModel('/api/dq/sv_affirmation_submission_conflict')
				.setEntityName('affirmationSubmissionConflict')
				.setProcessFilter(getNsndTokenFilterProcessor(['title', 'recording_name']))
				.setOutput([
					'distribution_period_id',
					'type',
					'title',
					'total_share_pct',
					'producers',
					'status',
					'admin_comments',
				])
				.getState()
		);
	}

	setConflictIsPublic(id, isPublic) {
		const conflictRowPath = ['conflicts', 'data', 'result', 'data', 'rows'];
		const rows = this.#data.getIn(conflictRowPath) || EMPTY_LIST;
		const rowIdx = rows.findIndex(row => row.get('id') === id);
		if (rowIdx < 0) {
			return this;
		}
		return this.#setProperty(conflictRowPath, rows.setIn([rowIdx, 'is_public'], isPublic));
	}

	setAnomalyAdminComments(id, value) {
		const rowPath = ['anomalies', 'data', 'result', 'data', 'rows'];
		const rows = this.#data.getIn(rowPath) || EMPTY_LIST;
		const rowIdx = rows.findIndex(row => row.get('id') === id);
		if (rowIdx < 0) {
			return this;
		}
		return this.#setProperty(rowPath, rows.setIn([rowIdx, 'admin_comments'], value));
	}


	setConflictAdminComments(id, value) {
		const rowPath = ['conflicts', 'data', 'result', 'data', 'rows'];
		const rows = this.#data.getIn(rowPath) || EMPTY_LIST;
		const rowIdx = rows.findIndex(row => row.get('id') === id);
		if (rowIdx < 0) {
			return this;
		}
		return this.#setProperty(rowPath, rows.setIn([rowIdx, 'admin_comments'], value));
	}

	setSubmissionAdminComments(id, value) {
		const rowPath = ['esad', 'data', 'search', 'data', 'result', 'data', 'rows'];
		const rows = this.#data.getIn(rowPath) || EMPTY_LIST;
		const rowIdx = rows.findIndex(row => row.get('id') === id);
		if (rowIdx < 0) {
			return this;
		}
		return this.#setProperty(rowPath, rows.setIn([rowIdx, 'admin_comments'], value));
	}

	setEntitySearchAndDetail(model) {
		return new AffirmationSubmissionAdminModel(this.#data.set('esad', model.getState()));
	}

	getEntitySearchAndDetail() {
		return createModelForState(this.#data.get('esad'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}




function searchTabProps(ctx) {
	const detail = ctx.getRootProperty('detail');
	return {
		fixedFilter: {
			party_id: detail.get('partyId'),
			distribution_period_id: detail.get('distributionPeriodId'),
			role_type_id: detail.get('roleTypeId')
		},
		customResultProps: searchTabCustomResultProps
	};
}

async function setStatus(distributionPeriodId, partyId, roleTypeId, statusId, comments) {
	const res = await webapi.execute('/api/proc/api_affirmations/setStatus', {
		distributionPeriodId,
		partyId,
		roleTypeId,
		statusId,
		comments
	});
	if (res === REPORTED_EXCEPTION) {
		return false;
	}
	updateEntityTimestamp('affirmationSubmission');
	return true;
}

let detailDefinition = Container([
	TabPane().setTabs([
		Tab('basicInfo', getPhrase('basicInfo')).setContent(
			Centerer(
				Form().setBasePath('detail').setItems([
					MessageDefinition(ctx => {
						return (
							<LatestStatus
								transitions={ctx.getProperty('transitions')}
							/>
						);
					}),
					FormItem('distributionPeriodId', 'lookup').setLookup('affirmationDistributionPeriod').setReadOnly(true),
					FormItem('partyName', 'text').setReadOnly(true).setLabel(ctx => getFormItemLabel('role_id.submission')),
					FormItem('isImported', 'lookup').setLookup('ynBoolean').setReadOnly(true).setLabel(ctx => getFormItemLabel('importedFromExcel')),
					MessageDefinition(ctx => {
						const stats = getTotalStats(ctx);
						return (
							<DisclaimerWrapper margin="16px 0px">
								{renderTotalTable(stats)}
							</DisclaimerWrapper>
						);
					}),
					Cross().setJustifyContent('right').setItems([
						Button('exportToExcel', getPhrase('exportToExcel'))
							.setType('medium')
							.setListener(e => {
								const ctx = e.ctx;
								const pars = {
									distributionPeriodId: ctx.getProperty('distributionPeriodId'),
									partyId: ctx.getProperty('partyId'),
									roleTypeId: ctx.getProperty('roleTypeId')
								};
								const fileName = 'Podání ČP VZOZ - ' + ctx.getProperty('partyName').replace(/[\W]+/g, ' ') + '__' + pars.distributionPeriodId + '_' + pars.partyId + '.xlsx';
								exportToExcel('API_AffirmationAdminExcelExport', pars, fileName);
							}),
					]),
					MessageDefinition(ctx => {
						const statusId = ctx.getProperty('statusId');
						const withStateTransfers = statusId === 'SUBMITTED' || statusId === 'IN_PROGRESS';
						const lookup = getLookup('submissionStatus');

						return (
							<>
								{
									withStateTransfers &&
									<StatusButtonRow>
										<Label>{getPhrase('setSubmissionStateTo')}:</Label>
										{
											[
												'IN_PROGRESS',
												'RETURNED',
												'COMPLETED',
												'DENIED',
											].map(toStatusId => {
												if (statusId === toStatusId) {
													return null;
												}
												return <ButtonComponent
													key={toStatusId}
													text={lookup.getText(toStatusId)}
													negative={toStatusId === 'RETURNED' || toStatusId === 'DENIED'}
													onAction={async () => {
														const comments = await showMessageBox(getFormItemLabel('comments'), {
															type: 'input',
															multiline: true,
															optional: true,
															header: getPhrase('setStatusTo').replace('$status', lookup.getText(toStatusId))
														});
														if (comments === null) {
															return;
														}
														if (await setStatus(ctx.getProperty('distributionPeriodId'), ctx.getProperty('partyId'), ctx.getProperty('roleTypeId'), toStatusId, comments)) {
															ctx.setModel(await ctx.getModel().reload());
														}
													}}
													type="medium"
													marginRight="8px"
												/>;
											})
										}
									</StatusButtonRow>

								}
							</>
						);
					})
				])
			)
		),
		Tab('cinemaAttendanceSearch', getFormItemLabel('cinemaAttendance')).setContent(
			getSearchDefinition(
				'affirmationCinemaAttendanceSearch',
				'/api/dq/sv_affirmation_cinema_attendance',
				[],
				'affirmationCinemaAttendance',
				['tmp'],
				true
			).setProps(searchTabProps).func('setProcessFilter', getNsndTokenFilterProcessor(['original_recording_name', 'recording_name']))
		),
		Tab('broadcastSearch', getFormItemLabel('broadcast')).setContent(
			getSearchDefinition(
				'broadcastSearch',
				'/api/dq/sv_affirmation_broadcast',
				[],
				'affirmationBroadcast',
				['tmp'],
				true
			).setProps(searchTabProps).func('setProcessFilter', getNsndTokenFilterProcessor(['original_recording_name', 'recording_name']))
		),
		Tab('saleSearch', getFormItemLabel('sale')).setContent(
			getSearchDefinition(
				'affirmationSaleSearch',
				'/api/dq/sv_affirmation_sale',
				[],
				'affirmationSale',
				['tmp'],
				true
			).setProps(searchTabProps)
		),
	]),
	getCorrectionMessageDefinition(),
	// getImportErrorDialog('pressdata', stgPressdataCustomResultProps),
]);


const getTotalSales = memoizeOne(rows => {
	const physical = {};
	const digital = {};
	if (rows) {
		rows.forEach(row => {
			const p = row.get('physicalSaleIncome');
			const d = row.get('digitalSaleIncome');
			const curr = row.get('currency');
			if (!curr) {
				return;
			}
			if (p) {
				physical[curr] = (physical[curr] || 0) + p;
			}
			if (d) {
				digital[curr] = (digital[curr] || 0) + d;
			}
		});
	}
	return {
		physical: totalSaleMap2Array(physical),
		digital: totalSaleMap2Array(digital)
	};
});

const getSavedStats = memoizeOne(detail => {
	let res = (detail.get('savedStats') || EMPTY_MAP).toJS();
	if (!res.physicalSales) {
		res.physicalSales = [];
	}
	if (!res.digitalSales) {
		res.digitalSales = [];
	}
	return res;
});

function getTotalStats(ctx) {
	const data = ctx.getRootProperty('detail');
	let res = getSavedStats(data);
	res.hasData = res.cinemaAttendance > 0 || res.broadcastRuntime > 0 || res.physicalSales.length > 0 || res.digitalSales.length > 0;
	return res;
}

let currencyDetailDefinition = Centerer(
	Form().setItems([
		TabularInput().setPath(['detail', 'exchangeRates']).setItems([
			FormItem('distributionPeriodId', 'lookup').setLookup('affirmationDistributionPeriod').setWidth('210px').setReadOnly(true),
			FormItem('currencyId', 'text').setReadOnly(true),
			FormItem('exchangeRate', 'number').setMaxDecimals(4)
		]).setNoCreate(true).setDeletable(false),
		Cross().setJustifyContent('right').setItems([
			Button('reload', getPhrase('reload')).setListener(async e => {
				const ctx = e.ctx;
				ctx.setModel(await ctx.getModel().reload());
			}).setDisabled(ctx => ctx.getRootProperty('detail') !== ctx.getRootProperty('originalDetail'))
		])
	])
);

let currencyDetailModel = null;
function getCurrencyDetailModel() {
	if (!currencyDetailModel) {
		DefinitionUtils.setLabels(currencyDetailDefinition, 'currency');

		currencyDetailModel = new EntityDetailModel()
			.setLoadUri('/api/proc/api_exchangerates/getExchangeRateDetail')
			.setSaveUri('/api/proc/api_exchangerates/saveExchangeRates')
			.setDefinition(currencyDetailDefinition)
			.setLifeCycleListener(pars => {
				if (pars.type === 'save') {
					updateEntityTimestamp('producerSummary');
				}
			})
			.setEntityName('currency');
	}
	return currencyDetailModel;
}


let detailModel = null;

function getDetailModel() {
	if (!detailModel) {
		DefinitionUtils.setLabels(detailDefinition, 'affirmationSubmission');

		detailModel = new EntityDetailModel()
			.setLoadUri('/api/proc/api_affirmations/getSubmissionDetail')
			.setDefinition(detailDefinition)
			.setRightToolbar((ctx, params) => {
				const statusId = ctx.getRootProperty(['detail', 'statusId']);
				return (
					<>
						<StatusBubble className={statusId} marginLeft="16px">
							{ctx.getRootProperty(['detail', 'status'])}
						</StatusBubble>
					</>
				);
			})
			.setHeader(data => {
				const detail = data.get('detail') || EMPTY_MAP;
				const id = detail.get('id');
				return (
					<ModuleHeader>
						{
							id ? (
								<>
									<ModuleHeaderItem light>{detail.get('distributionPeriodId')}</ModuleHeaderItem>
									<ModuleHeaderItem>{detail.get('partyName')}</ModuleHeaderItem>
									<ModuleHeaderItem light>{detail.get('roleType')}</ModuleHeaderItem>
								</>
							) : (
								<ModuleHeaderItem>{getPhrase('newAffirmationSubmission')}</ModuleHeaderItem>
							)
						}
					</ModuleHeader>
				);
			})
			.setEntityName('affirmationSubmission');
	}
	return detailModel;
}

const StatusButtonRow = styled.div`
	margin-bottom: 24px;
	.ps-button {
		margin-right: 8px !important;
	}
`;
